export * from './MainButtons.style';
